import { Flex } from '@hopin-team/ui-flex';
import { calcSpace } from '@hopin-team/ui-symbols';
import styled from 'styled-components';

export const TemplateModalErrorRoot = styled(Flex)`
  margin: ${calcSpace(10)} auto 0;
  width: ${calcSpace(50)};
`;
